/**
 * api统一管理
 */
import { get, post } from './http';

// 注册1-发送邮箱验证
export const apiAuthRegisterEmail = (p) => post('/api/auth/register/email', p);
// 注册2-保存
export const apiAuthRegisterSave = (p) => post('/api/auth/register/save', p);
// 按域名解析公司信息
export const apiFreeCompany = (p) => post('/api/free/company', p);
// 登录
export const apiAuthLogin = (p) => post('/api/auth/login', p);
// 登录-发送邮箱验证
export const apiAuthLoginEmail = (p) => post('/api/auth/login/email', p);
// 忘记密码-邮箱发送-step1
export const apiAuthForgotEmail = (p) => post('/api/auth/forgot/email', p);
// 忘记密码-验证-step2
export const apiAuthForgotValid = (p) => post('/api/auth/forgot/valid', p);
// 忘记密码-重置密码保存-step3
export const apiAuthForgotSave = (p) => post('/api/auth/forgot/save', p);
// 退出登录
export const apiAuthLogout = (p) => get('/api/auth/logout', p);
// 修改密码验证邮箱
export const apiCommonUpdatePasswordEmail = (p) => post('/api/common/update/password/email', p);
// 修改密码
export const apiCommonUpdatePassword = (p) => post('/api/common/update/password', p);
// 获取基础信息-个人信息
export const apiCommonInfo = (p) => post('/api/common/info', p);
// 修改基础信息
export const apiCommonUpdateInfo = (p) => post('/api/common/update/info', p);
// 心跳-新增数据
export const apiReportLogAdd = (p) => post('/api/report/log/add', p);
// 全局心跳
export const apiHeart = (p) => post('/api/heart', p);
// 查询提醒信息
export const apiCommonSearch = (p) => post('/api/common/search', p);
// 确认知悉
export const apiCommonConfirm = (p) => post('/api/common/confirm', p);

/**
 * 客户周报
 */
// 厂家周报年份查询
export const apiFreeWeeklyYears = (p) => post('/api/weekly/years', p);
// 周报列表-(按年:全量)
export const apiFreeWeeklyList = (p) => post('/api/weekly/list', p);
// 周报板块
export const apiFreeWeeklyModular = (p) => post('/api/weekly/modular', p);
// 文章列表(分页)
export const apiFreeWeeklyArticleList = (p) => post('/api/weekly/article/list', p);
// 周报详情
export const apiFreeWeeklyId = (p) => post('/api/weekly/id', p);
// 文章详情
export const apiFreeWeeklyArticleId = (p) => post('/api/weekly/article/id', p);
// 上一条&下一条
export const apiFreeWeeklyArticleNext = (p) => post('/api/weekly/article/next', p);
// 获取微信签名
export const apiFreeWeeklyJsSign = (p) => post('/api/weekly/js_sign', p);
// 周报板块(树形+统计)
export const apiFreeWeeklyModularStats = (p) => post('/api/weekly/modular/stats', p);
// 文章列表(板块关键词关联)
export const apiFreeWeeklyArticleRelated = (p) => post('/api/weekly/article/related', p);
// 周报板块详情
export const apiFreeWeeklyModularId = (p) => post('/api/weekly/modular/id', p);
// 文章搜索
export const apiWeeklyArticleSearch = (p) => post('/api/weekly/article/search', p);
// 分享
export const apiWeeklyShareCreate = (p) => post('/api/weekly/share/create', p);
// 保存分享浏览日志
export const apiShareLog = (p) => post('/api/share/log', p);
// 文章发布人列表(全量)
export const apiWeeklyArticleRelease = (p) => post('/api/weekly/article/release', p);
// 搜索板块字典
export const apiWeeklyModularList = (p) => post('/api/weekly/modular/list', p);
// 周列表
export const apiWeeklyWeek = (p) => post('/api/weekly/week', p);
// 文章国家
export const apiWeeklyArticleCountry = (p) => post('/api/weekly/article/country', p);
// 修改文章风险等级
export const apiWeeklyRisk = (p) => post('/api/weekly/risk', p);
// 文章列表导出
export const apiWeeklyExport = () => '/api/weekly/export';
// 接收-不接收邮件警告
export const apiRecipientWarning = (p) => post('/api/recipient/warning', p);

/**
 * 收藏夹
 */
// 我的收藏夹(全量选择)
export const apiFavoriteAll = (p) => post('/api/favorite/all', p);
// 收藏夹-添加文章
export const apiFavoriteArticleAdd = (p) => post('/api/favorite/article/add', p);
// 收藏夹-移除文章
export const apiFavoriteArticleRemove = (p) => post('/api/favorite/article/remove', p);
// 新增收藏夹
export const apiFavoriteSave = (p) => post('/api/favorite/save', p);
// 收藏夹-文章列表-TODO
export const apiFavoriteArticleList = (p) => post('/api/favorite/article/list', p);
// 修改收藏夹
export const apiFavoriteMod = (p) => post('/api/favorite/mod', p);
// 除收藏夹
export const apiFavoriteDel = (p) => post('/api/favorite/del', p);
// 文章ID列表
export const apiFavoriteIdList = (p) => get('/api/favorite/id/list', p);

/**
 * 收件人
 */
// 收件分组列表
export const apiRecipientGroupList = (p) => post('/api/recipient/group/list', p);
// 新增收件分组
export const apiRecipientGroupAdd = (p) => post('/api/recipient/group/add', p);
// 编辑收件分组
export const apiRecipientGroupUpdate = (p) => post('/api/recipient/group/update', p);
// 删除收件分组
export const apiRecipientGroupDelete = (p) => post('/api/recipient/group/delete', p);
// 新增收件人
export const apiRecipientAdd = (p) => post('/api/recipient/add', p);
// 编辑收件人
export const apiRecipientUpdate = (p) => post('/api/recipient/update', p);
// 收件人列表
export const apiRecipientList = (p) => post('/api/recipient/list', p);
// 删除收件人
export const apiRecipientDelete = (p) => post('/api/recipient/delete', p);
// 下载收件人模板-批量上传
export const apiRecipientTpl = () => '/api/recipient/tpl';
// 批量上传收件人
export const apiRecipientUpload = (p) => post('/api/recipient/upload', p);
// 收件分组全量(含人员)
export const apiRecipientGroupAll = (p) => post('/api/recipient/group/all', p);
// 发送报告
export const apiFavoriteEmail = (p) => post('/api/favorite/email', p);











